import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isMedia)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["q-mb-sm full-width", { 'slide-animation': !_ctx.isFirst }])
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.isMediaComponent.component), {
            src: _ctx.isMediaComponent.src,
            hosting: _ctx.isMediaComponent.hosting,
            isWidget: true,
            onLoaded: _cache[0] || (_cache[0] = (e) => _ctx.$emit('loaded'))
          }, null, 40, ["src", "hosting"]))
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.showText)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([{ 'slide-animation': !_ctx.isFirst }, "text"]),
          id: "trigger-preview-message"
        }, _toDisplayString(_ctx.message.text), 3))
      : _createCommentVNode("", true)
  ]))
}